var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import Uploader from '../../../common/components/uploader';
import VueDialog from '../../../interface/IVueDialog';
import LicenseService from "../../../api/LicenseService";
var UploadLicenseDialog = (function (_super) {
    __extends(UploadLicenseDialog, _super);
    function UploadLicenseDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            document_name: '',
            document_pic: [],
        };
        return _this;
    }
    UploadLicenseDialog.prototype.created = function () {
        this.service = LicenseService.getInstance();
    };
    UploadLicenseDialog.prototype.close = function () {
        this.$closeDialog();
    };
    UploadLicenseDialog.prototype.save = function () {
        var _this = this;
        var uploaderRef = this.$refs.uploader;
        if (uploaderRef && uploaderRef.$refs && uploaderRef.$refs.upload) {
            var uploadRef = uploaderRef.$refs.upload;
            var uploadFiles = uploadRef.uploadFiles;
            console.log('所有上传文件（包括正在上传的）：', uploadFiles);
            var hasUploadingFiles = uploadFiles.some(function (file) {
                return file.status === 'uploading' ||
                    file.status === 'ready' ||
                    (file.percentage !== undefined && file.percentage < 100);
            });
            if (hasUploadingFiles) {
                this.$message.warning('文件正在上传中，请上传完成后再操作！');
                return;
            }
        }
        if (!this.formData.document_pic.length) {
            this.$message.warning('请上传文件');
            return;
        }
        var hasUnuploadedFiles = this.formData.document_pic.some(function (item) {
            if (item.url && item.url.startsWith('blob:')) {
                return true;
            }
            if (item.status && item.status !== 'success') {
                return true;
            }
            if (!item.response && (!item.url || !item.url.startsWith('http'))) {
                return true;
            }
            return false;
        });
        if (hasUnuploadedFiles) {
            this.$message.warning('文件正在上传中，请上传完成后再操作！');
            return;
        }
        var document_pic = this.formData.document_pic
            .filter(function (item) { return item.url && item.url.startsWith('http'); })
            .map(function (item) { return item.url; });
        if (document_pic.length === 0) {
            this.$message.warning('没有有效的文件，请重新上传');
            return;
        }
        if (document_pic.length !== this.formData.document_pic.length) {
            this.$message.warning('部分文件尚未上传完成，请稍候再试！');
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .licenseOrderAdd({
            delivery_order_id: this.delivery_order_id,
            delivery_order_detail_id: this.delivery_order_detail_id,
            document_name: this.formData.document_name,
            document_pic: document_pic
        })
            .then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg || '上传成功');
            _this.close();
            _this.$emit('upload_liscense:ok');
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    UploadLicenseDialog = __decorate([
        Component({
            components: {
                uploader: Uploader,
            },
        })
    ], UploadLicenseDialog);
    return UploadLicenseDialog;
}(VueDialog));
export default UploadLicenseDialog;
